import React, { useEffect, useState } from 'react';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import '../../assets/css/TermsandCondition.css';
import { StaticPages } from '../../Redux/services/Apis';
import axios from 'axios';
import { showLoader } from '../../Redux/services/Loader';
import { toast } from 'react-toastify';

const TermsCondition = () => {
    const [state, setState] = useState(null);
    const [dateNow, setDateNow] = useState(null);

    useEffect(() => {
        window.scroll(0, 0);
    }, [])

    useEffect(() => {
        showLoader('flex');
        axios.get(StaticPages, {
            headers: {
                "Application-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            }
        }).then((res) => {
            // console.log(res?.data?.response?.data?.data[2]);
            setState(res?.data?.response?.data?.data[2]?.content);
            setDateNow(res?.data?.response?.data?.data[2]?.created_at.slice(0, 10));
            showLoader('none');
        })
            .catch(error => {
                // console.log('error from checkredux page', error)
                toast.error("Network Error");
                showLoader('none');
            })

    }, [])
    return (
        <div className='termsandcondition'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"TERMS & CONDITION"} />
            </section>
            <section className='terms_condition'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <p className='f-mon-bold f-35 mb-1'>TERMS & CONDITION</p>
                            <div className='border-pink-aboutus-know '>

                            </div>
                            <div className='date_affective'>
                                <p>Date Effective : <span>({dateNow})</span> </p>
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: state }} className='f-mon-light f-18 mb-0 mt-5'>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default TermsCondition;